
/**
 * An object in charge of the templating.
 *
 * @class
 *
 * @param {PrediggoService} service The service in charge of
 * communicating with the core.
 */
export default function Templating(service) {

    this.service = service;

    this.func = new this.Func();

}

/**
 * Adds a notify event to all the elements in a subtree bearing
 * a 'data-prd-notif' attribute.
 *
 * The value of the attribute should be a tracking-code.
 *
 * @public
 *
 * @param {Object} parent The parent element of the subtree to inspect.
 */
Templating.prototype.addNotify = function (parent) {

    // Shouldn't we rather add the notification when the elements are constructed with a data-prd-notif ???

    var elements = jQuery(parent).find('[data-prd-notif]');

    var this_ = this;

    elements.each(function () {

        var element = jQuery(this);

        var trackingCode = element.attr('data-prd-notif');
        if (!trackingCode) {
            return;
        }

        (function (code) {
            // Tracks the clicks
            element.click(function (event) {
                this_.service.notify(code, function (data) { }, function (data) { });
            });
            // Tracks the mouse-down
            element.mousedown(function (event) {
                this_.service.notify(code, function (data) { }, function (data) { });
            });
        })(trackingCode);


    });

};


/**
 * Adds a click event to the elements of a subtree decorated with 'data-prd-refiningid'
 * with the effect of refining the content.
 *
 * @public
 *
 * @param {object} parent The parent element of the subtree to inspect.
 * @param {function} success The function called in case of success. This should handle the
 * new data resulting from the refinement and display them where appropriate.
 * @param {function} error The function called in case of failure.
 *
 */
Templating.prototype.addRefine = function (parent, success, error) {

    parent = jQuery(parent);

    var elements = parent.find('[data-prd-refiningid]');

    var this_ = this;

    elements.each(function () {

        var element = jQuery(this);
        if (element.prop('tagName') === 'OPTION') {
            return; // options are handled with the selects
        }

        var refineId = element.attr('data-prd-refiningid');
        if (!refineId) {
            return;
        }

        (function (refId) {
            element.click(function (event) {
                this_.service.refine(refId, success, error);
            });
        })(refineId);

    });

    // We handle the special case of the selects because options are
    // not clickable in all browsers
    this.addRefineToSelect(parent, success, error);

};

/**
 * Adds an onChange event to the selects whose options are decorated
 * with 'data-prd-refiningid' with the effect of refining the content.
 *
 * @public
 *
 * @param {object} parent The parent element of the subtree to inspect.
 * @param {function} success The function called in case of success. This should handle the
 * new data resulting from the refinement and display them where appropriate.
 * @param {function} error The function called in case of failure.
 *
 */
Templating.prototype.addRefineToSelect = function (parent, success, error) {

    var selects = parent.find('SELECT');

    var this_ = this;

    selects.each(function () {
        var select = jQuery(this);
        select.change(function () {
            var selected = parent.find('OPTION:selected');
            var refineId = selected.attr('data-prd-refiningid');
            if (refineId) {
                this_.service.refine(refineId, success, error);
            }
        });

    });

};

/**
 * Prints a message into the console if the flag 'verbose' is
 * true.
 *
 * @param {String} msg A message to print.
 *
 */
Templating.prototype._printIfverbose = function (msg) {
    if (this.service) {
        this.service.log(msg);
    }
};

/**
 * Creates a copy of a template object, fills it with JSON data and
 * appends the result into a given DOM object (the parent).
 *
 * The template should be a DOM object with text nodes and attribute
 * values possibly containing variables within pairs of curly brackets
 * '{{...}}'. The variables will be replaced with values mentioned in
 * the JSON.
 *
 *
 * The values should be specified by their names and path in the
 * JSON object following standard Javascript dot notation.
 *
 *
 * Template elements marked with 'data-prd-foreach' followed
 * by the path of an array field in the JSON will be copied and
 * filled over each elements of array in turn. The variables inside
 * the scope of a 'data-prd-foreach will be interpreted as relative
 * to the current element.
 *
 *
 * If the template contains elements with 'data-prd-function'
 * attributes, the value of which will be called as a function
 * onto the object just created. A similar-named function should
 * be defined an be attached to the 'this.func' field in the current
 * Templating object.
 *
 *
 * Finally a click-event triggering a tracking-notification to Prediggo
 * will be attached to elements decorated with 'data-prd-notif'.
 *
 * @public
 *
 * @param {Object} template The template.
 * @param {Object} json A JSON object.
 * @param {Object} parent A DOM object.
 *
 */
Templating.prototype.render = function (template, json, parent) {

    if (!template || template.length === 0) {
        this._printIfverbose('No template passed to render()');
        return;
    }

    if (parent === null || parent === undefined) {
        parent = jQuery('<div></div>');
    }

    parent.empty();

    // This is a hack to prevent the upload of 'src' url in the templates with
    // older versions of jQuery.
    // In the future, we will perhaps remove it
    var doc = document; // by default
    if (document.implementation && document.implementation.createHTMLDocument) {
        // If possible we create a new document
        doc = document.implementation.createHTMLDocument("");
    }

    var templ = jQuery(jQuery.parseHTML('<div>' + template.text() + '</div>', doc));
    //var div = newDoc.createElement('DIV');
    //div.innerHTML = template.text();
    //var templ = jQuery(div);

    if (!templ || templ.length === 0 || templ.children().length === 0) {

        this._printIfverbose('Template passed to render() does not seem to be a valid template');
        return;

    }

    var this_ = this;

    templ.children().each(function (index, element) {
        var elem = jQuery(element);
        this_._fillTemplate(elem, json, parent);
    });

    this.addNotify(parent);

    return parent; // In a next version we should test if we return the parent or its content.
    // So far we do not use the return value and keep it so
};


/**
 * Finds a value (Object, String, Array, etc.) inside a JSON object
 * given a path in dot notation.
 *
 * @private
 *
 * @param {string} path A path composed of field names separated by dots.
 * @param {Object} json A JSON object.
 *
 */
Templating.prototype._lookupByName = function (path, json) {

    path = path.trim();
    if (path === '.') {
        return json;
    }

    path = path.replace(/\[(\w+)\]/g, '.$1');

    var fragments = path.split(/\./g);

    for (var i = 0; i < fragments.length; i++) {

        var frag = fragments[i];

        if (json instanceof Array && json.length > 0) {

            try {

                var fragNum = parseInt(frag);
                json = json[fragNum];

            } catch (ex) {
                // eslint-disable-line 
            }

        } else if (json[frag] !== undefined && json[frag] !== null) {

            json = json[frag];

        } else {

            return null;

        }

    }

    return json;
};

/**
 * Replaces the variables enclosed within '{{...}}' in a text
 * with the corresponding values found in a JSON object.
 *
 * @private
 *
 * @param {string} text Some string of character.
 * @param {Object} json A JSON object.
 *
 */
Templating.prototype._replace = function (text, json) {

    var regexp = /{{(\s*.+?\s*)}}/g;
    var match = regexp.exec(text);
    var matches = [];
    while (match != null) {
        var sub = match[1];
        matches.push(sub);
        match = regexp.exec(text);
    }

    for (var i = 0; i < matches.length; i++) {
        match = matches[i];
        var subst = this._lookupByName(match, json);
        if (subst === null || subst === undefined) {
            subst = '';
        }
        text = text.replace('{{' + match + '}}', subst);
    }

    return text;
};

/**
 * Replaces the '{{...}}'-variables in a DOM element with
 * the corresponding values mentioned in a JSON object.
 *
 * @private
 *
 * @param {Object} element A DOM element.
 * @param {Object} json A JSON object.
 */
Templating.prototype._setValuesInElement = function (element, json) {

    // add a check for length here...

    var attributes = element[0].attributes;
    if (attributes === undefined || attributes === null || !attributes.length) {
        return;
    }
    for (var i = 0; i < attributes.length; i++) {
        attributes[i].value = this._replace(attributes[i].value, json);
    }

};


/**
 * Replaces the '{{...}}'-variables in a text-node with
 * the corresponding values mentioned in a JSON object.
 *
 * @private
 *
 * @param {Object} element A DOM element.
 * @param {Object} json A JSON object.
 */
Templating.prototype._setValuesInTextNode = function (node, json) {

    node.nodeValue = this._replace(node.nodeValue, json);

    return jQuery(node);
};


/**
 * Fills a template with the values mentioned in a JSON object and
 * appends the result into a DOM element (the parent).
 *
 * @private
 *
 *
 * @param {Object} template A DOM object representing a template.
 * @param {Object} json A JSON object.
 * @param {Object} parent A DOM object into which the final template
 * will be appended.
 *
 */
Templating.prototype._fillTemplate = function (template, json, parent) {

    if (json === undefined || json === null || json === '') {
        this._printIfverbose('Json unavailable in render(): ' + JSON.stringify(json));
        return;
    }

    var forEach = template.attr('data-prd-foreach');
    if (forEach) {
        json = this._lookupByName(forEach, json);
        if (json === null) {
            //this._printIfverbose('Json null after look-up in render() for ' + forEach);
            return;
        }
        template = template.clone();
        template.removeAttr('data-prd-foreach');
    }

    if (json instanceof Array) {

        for (var i = 0; i < json.length; i++) {
            this._fillTemplate(template.clone(), json[i], parent);
        }
        return;
    }

    var newParent = template.clone();
    newParent.empty();
    this._setValuesInElement(newParent, json);

    var this_ = this;

    template.contents().each(function (index, child) {

        if (child.nodeType === 3) {
            newParent.append(this_._setValuesInTextNode(child, json));
        } else {
            this_._fillTemplate(jQuery(child), json, newParent);
        }
    });


    var funct = template.attr('data-prd-function');
    try {
        if (funct && this.func[funct]) {
            this.func[funct](newParent, json);
        } else if (funct) {
            this._printIfverbose('Custom function ' + funct + ' is not defined.');
        }
    } catch (err) {
        console.log('Error in function ' + funct + ': ' + err);
    }

    parent.append(newParent);
};



/**
 * The object that will contain the custom function used by Templating.
 * Can also contain pre-coded function.
 *
 * @class
 */
Templating.prototype.Func = function () { };

/**
 * Adds a 'selected=true' attribute to an object if
 *
 */
Templating.prototype.Func.prototype.selected = function (element, json) {
    if (json.selected) {
        element.attr('selected', 'true');
    }
};
